import { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";
import { formatApiError } from "../lib/AuthContext";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next");

  // Al ingelogd als admin? Direct door naar het dashboard (ook bij browser "terug").
  useEffect(() => {
    if (localStorage.getItem("joh_admin_token")) nav(next || "/admin", { replace: true });
  }, [nav, next]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (!["admin", "owner"].includes(data?.user?.role)) {
        toast.error("Dit account heeft geen admin-toegang");
        setLoading(false);
        return;
      }
      localStorage.setItem("joh_admin_token", data.token);
      localStorage.setItem("joh_auth_token", data.token); // één sessie: admin blijft ook op de site ingelogd
      toast.success("Ingelogd");
      nav(next || "/admin");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Login mislukt");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F5F3F0] grain grain-dark flex" data-testid="admin-login-page">
      <div className="hidden md:flex flex-col justify-between w-1/2 p-10 line-t line-dark">
        <Link to="/" className="font-logo text-3xl" data-testid="admin-back-home">JOH.</Link>
        <div>
          <motion.h1
            initial={{ y: 40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="font-display uppercase text-[9vw] leading-[0.86]"
          >
            Coach's<br/><span className="font-serif-italic normal-case tracking-tight">corner.</span>
          </motion.h1>
          <p className="chip text-[#A3A3A3] mt-6">Admin only / manage submissions</p>
        </div>
        <div className="chip text-[#A3A3A3]">© JOH. Boxing 2026</div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6 md:p-10">
        <motion.form
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.7 }}
          onSubmit={submit}
          className="w-full max-w-md border border-[#F5F3F0]/20 p-8 md:p-10"
          data-testid="admin-login-form"
        >
          <div className="chip text-[#A3A3A3] mb-2">— Login</div>
          <h2 className="font-display uppercase text-4xl md:text-5xl">Enter the gym.</h2>
          <div className="mt-8 space-y-6">
            <div>
              <label className="chip text-[#A3A3A3]">E-mail</label>
              <input required type="email" value={email} onChange={(e)=>setEmail(e.target.value)} className="editorial-input dark" data-testid="admin-email" />
            </div>
            <div>
              <label className="chip text-[#A3A3A3]">Wachtwoord</label>
              <input required type="password" value={password} onChange={(e)=>setPassword(e.target.value)} className="editorial-input dark" data-testid="admin-password" />
            </div>
          </div>
          <button disabled={loading} type="submit" className="btn-light mt-8 w-full justify-center" data-testid="admin-login-btn">
            {loading ? "Inloggen…" : "Login"} <ArrowUpRight size={14}/>
          </button>
        </motion.form>
      </div>
    </div>
  );
}
